/**
 * Streaks MFE Route
 * 
 * Loads and renders the Streaks MFE for daily activity tracking.
 * 
 * @module components/mfe/StreaksRoute
 */

import React from 'react';
import { MFELoader } from './MFELoader';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const StreaksRoute: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <MFELoader
      mfeName="Streaks"
      accessToken={token}
      refUserId={user.id}
      onLogout={logout}
    />
  );
};

